// TypeScript interfaces matching backend API DTOs
export var MessageSeverity;
(function (MessageSeverity) {
    MessageSeverity["Error"] = "Error";
    MessageSeverity["Warning"] = "Warning";
    MessageSeverity["Info"] = "Info";
})(MessageSeverity || (MessageSeverity = {}));
// Format detection
export var DocumentFormat;
(function (DocumentFormat) {
    DocumentFormat["Unknown"] = "Unknown";
    DocumentFormat["Text"] = "Text";
    DocumentFormat["SRT"] = "SRT";
    DocumentFormat["AvidDS"] = "AvidDS";
})(DocumentFormat || (DocumentFormat = {}));
// Supported conversions map
export const SUPPORTED_CONVERSIONS = {
    'AvidDS': ['Excel'],
    'SRT': ['AvidDS'],
    'Text': ['AvidDS']
};
// Frame rates
export const FRAME_RATES = [
    { value: 'Smpte24', label: '24 fps' },
    { value: 'Smpte25', label: '25 fps' },
    { value: 'Smpte2997', label: '29.97 fps' },
    { value: 'Smpte30', label: '30 fps' }
];
